import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { ResponsiveContainer } from "recharts";
import { cn } from "@/lib/utils";

/** Recharts needs a parent with measurable width/height before mount. */
export function ChartContainer({ className, style, children }) {
  const ref = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    let raf = 0;
    const check = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const { width, height } = el.getBoundingClientRect();
        setReady(width > 0 && height > 0);
      });
    };

    check();
    const ro = new ResizeObserver(check);
    ro.observe(el);
    return () => {
      cancelAnimationFrame(raf);
      ro.disconnect();
    };
  }, []);

  return (
    <div ref={ref} className={cn("w-full min-w-0 min-h-0", className)} style={style}>
      {ready ? (
        <ResponsiveContainer width="100%" height="100%" minWidth={0} debounce={50}>
          {children}
        </ResponsiveContainer>
      ) : null}
    </div>
  );
}

ChartContainer.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};
